module.exports = __webpack_public_path__ + "img/室内机.d9c24318.jpg";